import React from "react";
import "../css/about.scss";
import { STORE_CONFIG } from "../config/storeConfig";

function About() {
  return (
    <main className="about main"><div className="about-container">
      <h1 className="about-title">A CLEARER WAY TO CARRY</h1>
      <div className="about-image"><img src="/main/about.png" alt="Unbranded leather, canvas and nylon bag materials on a studio table" /></div>
      <div className="about-text">
        <p>{STORE_CONFIG.brand} is a bag-focused online store operated from {STORE_CONFIG.operatingRegion}. The collection moves from compact crossbody bags and soft shoulder shapes to work totes, backpacks and short-trip holdalls.</p>
        <p>We favour clear function over invented provenance. Each listing records dimensions, main materials, intended contents, carrying options, care and relevant load or colour-transfer cautions.</p>
        <p>The visual language is original to this store: natural light, honest grain and weave, and unbranded bags shown from more than one useful angle.</p>
      </div>
    </div></main>
  );
}

export default About;
